import { useLocation, useNavigate } from 'react-router-dom';
import { IconBell, IconSparkle } from './Icons';

// Per-route title + subtitle for the top bar. The page bodies no longer repeat
// their own <h1>; the top bar is the single source of the page heading.
const TITLES: Record<string, [string, string]> = {
  '/': ['Accueil', "Votre centre de contrôle — l'activité du jour en un coup d'œil."],
  '/tableaux': ['Tableaux de bord', "Chiffre d'affaires, marges et niveaux de stock."],
  '/chat': ['Assistant', 'Pilotez Odoo en langage naturel.'],
  '/ventes': ['Ventes', 'Devis → commande → livraison → facture → paiement.'],
  '/stocks': ['Stocks', 'Niveaux, réservations et seuils de réapprovisionnement.'],
  '/achats': ['Achats', 'Factures fournisseurs et état de réception.'],
  '/journal': ['Journal technique', 'Erreurs et alertes des automatisations n8n / Odoo.'],
  '/conversations': ['Conversations', 'Historique de vos échanges avec l’assistant.'],
  '/admin': ['Administration', 'Gestion des utilisateurs de STM Bot.'],
};

export default function Topbar() {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const [title, sub] = TITLES[pathname] || TITLES[`/${pathname.split('/')[1]}`] || ['STM Partners', ''];

  return (
    <header className="app-topbar">
      <div className="app-topbar-title">
        <h1>{title}</h1>
        {sub && <p>{sub}</p>}
      </div>
      <div className="app-topbar-actions">
        <button className="topbar-icon-btn" title="Journal technique" onClick={() => nav('/journal')}>
          <IconBell size={18} />
          <span className="dot" />
        </button>
        <button className="topbar-ai-btn" onClick={() => nav('/chat')}>
          <IconSparkle size={16} />
          Demander à l'IA
        </button>
      </div>
    </header>
  );
}
